const t = (str) => str;

export default t;
